var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3076 0.836517C4.79762 0.836517 0.307617 5.32652 0.307617 10.8365C0.307617 16.3465 4.79762 20.8365 10.3076 20.8365C15.8176 20.8365 20.3076 16.3465 20.3076 10.8365C20.3076 5.32652 15.8176 0.836517 10.3076 0.836517ZM10.3076 18.8365C5.89762 18.8365 2.30762 15.2465 2.30762 10.8365C2.30762 6.42652 5.89762 2.83652 10.3076 2.83652C14.7176 2.83652 18.3076 6.42652 18.3076 10.8365C18.3076 15.2465 14.7176 18.8365 10.3076 18.8365ZM12.8976 7.42652L14.3076 8.83652L10.3076 12.8365L6.30762 8.83652L7.71762 7.42652L9.30762 9.00652V4.83652H11.3076V9.00652L12.8976 7.42652ZM15.3076 15.8365H5.30762V13.8365H15.3076V15.8365Z",
    fill: "#B4624D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadHover);
export default __webpack_public_path__ + "static/media/download-hover.0d82e505ca39d1af47806076be06b2a3.svg";
export { ForwardRef as ReactComponent };